// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3x2_f","error":"Textarea_error__gb1AJ","readonly":"Textarea_readonly__2I0z3","disabled":"Textarea_disabled__18mez"};